import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { TitleBlockInterface } from '~/types/AppData/PageBuilder/TitleBlockInterface';

export default component$<TitleBlockInterface['props']>(
  ({ text }): JSX.Element => {
    return <h2 class='font-group-huge text-center mb-6'>{text}</h2>;
  }
);
